

















































import Vue, { PropType } from 'vue'

import { StatusData } from '../../../typings/StatusData'

export default Vue.extend({
  name: 'status-compact-tile',
  props: {
    statusData: {
      type: Object as PropType<StatusData>
    },
    wbuuid: {
      type: String as PropType<string>,
      required: true,
    },
    isEditable: {
      type: Boolean
    },
    qualificationsAvailable: {
      type: Boolean,
      default: true,
    },
    showTotalAvailability: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    showStatusNames: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    fontSizes: {
      type: Object,
      default: () => {
        return {
          'statusNames': 18,
          'totalAvailability': 48,
          'qualificationsShortname': 14,
          'qualificationsCount': 14,
        }
      }
    }
  },
  methods: {
    getBackgroundColor() {
      if (this.statusData.color === 'FFFF00') return '#FFCE0D' // Alternative yellow with improved contrast
      if (this.statusData.color === '00FF00') return '#00BF00' // Alternative green with improved contrast

      return `#${this.statusData.color}`
    }
  }
})
